import { render, staticRenderFns } from "./DeviceLiveData.vue?vue&type=template&id=20966698"
import script from "./DeviceLiveData.vue?vue&type=script&lang=js"
export * from "./DeviceLiveData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports